// frontend/src/pages/AssignPoints/HabitSelectPage.js
// Source of truth: constants.json (no dummy data, no DB fetch here)
// Navigates to ReasonSelectPage with ?habit_name=<name>

import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import constants from "../../data/constants.json";

export default function HabitSelectPage() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();

  const habits = Object.keys(constants.habits || {});
 
  function choose(habitName) {
    const next = new URLSearchParams(sp);
    next.set("habit_name", habitName);
    // ✅ route matches routes.js
    navigate(`/assign/reasons?${next.toString()}`);
  }

  return (
    <div style={s.page}>
      <h1 style={s.h1}>Select Habit</h1>

      <div style={s.grid}>
        {habits.length === 0 && <div>No habits configured.</div>}

        {habits.map((name) => (
          <button key={name} style={s.card} onClick={() => choose(name)}>
            <div style={s.badge} aria-hidden="true" />
            <div style={s.title}>{name}</div>
            <div style={s.sub}>{(constants.habits[name] || []).join(" • ")}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

const s = {
  page: { padding: 16 },
  h1: { margin: 0, marginBottom: 12, color: "#003e73" },
  grid: { display: "grid", gap: 10, gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))" },
  card: {
    textAlign: "left",
    background: "#fff",
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 12,
    padding: 12,
    cursor: "pointer",
  },
  title: { fontWeight: 700, color: "#003e73", marginBottom: 4 },
  sub: { color: "#555" },
  badge: { width: 28, height: 8, borderRadius: 999, marginBottom: 10 },
};
